import React from "react";

export default function CmoLeadershipEventComponent() {
  return (
    <div className="about_area pt-45 pb-45">
      <div className="container">
        <div className="row">
          

          {/* Text Content Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3">
              
              <div className="section_main_title text-left">
                <h1>CMO Leadership Summit 2026: How ProPlus Data is Redefining Predictable Pipeline
                </h1>
                <p><b>Austin, TX | April 12–14, 2026</b></p>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
             
            </div>

            <div className="singel_about_left mb-30">
              <div className="singel_about_left_inner mb-3">
                <div className="singel-about-content text-left">
                    <p>As a sponsor at the CMO Leadership Summit 2026, ProPlus Data engaged with B2B marketing leaders tackling one of the biggest challenges in modern GTM strategy, pipeline predictability.</p>
                <p>
                Despite increased investments in intent data, AI-driven marketing, and demand generation, most teams still struggle to align execution with actual buyer readiness.

                </p>
                  
                 
                </div>
              </div>

              
            </div>
          </div>
          {/* Image Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb">
              <img src="/assets/images/cmo-summit-tx.jpg" alt="CMO Leadership Summit event" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
